<template>
  <base-card>
    <BaseCardTitle>
      <img
        src="/img/icon-cart.svg"
        alt
      >
      Activity
    </BaseCardTitle>
    <div
      v-for="cart in carts"
      :key="cart.pk"
    >
      <div class="d-flex justify-content-between mb-1">
        <div>
          <div>
            <small class="text-muted">{{ $moment(cart.created).format(dateformat) }}</small>
          </div>
          <div>
            <span
              class="mr-2"
            >{{ cart.customer.first_name }} {{ cart.customer.last_name }}</span>
          </div>
        </div>
      </div>
      <div>
        <div
          v-for="entry in cart.products"
          :id="entry.url"
          :key="entry.pk"
          class="mr-1 my-2 d-inline-block text-center"
        >
          <img
            class="mb-2"
            :src="entry.thumb"
            alt
            width="80"
          >
          <b-tooltip
            :target="entry.url"
            placement="top"
          >
            {{ entry.brand.name }}  <br>  ${{ entry.price }}
          </b-tooltip>
        </div>
      </div>
      <hr>
    </div>
    <!-- <ButtonMore /> -->
  </base-card>
</template>

<script>
export default {
  name: 'StylistActivity',
  props: {
    stylist: Number,
  },
  computed: {
    carts() {
      return this.$store.state.carts.items;
    },
  },
  mounted() {
    const args = {};
    if (this.stylist) {
      args.stylist = this.stylist;
    }
    this.$store.dispatch('carts/getAll', args);
  },
};
</script>

<style lang="scss" scoped>
</style>
